// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentLongResponse {
    static getAttributeTypeMap() {
        return DocumentLongResponse.attributeTypeMap;
    }
}
DocumentLongResponse.discriminator = undefined;
DocumentLongResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "number"
    }
];
//# sourceMappingURL=documentLongResponse.js.map